<template>
    <div
        class="formcontrol"
        :class="{
            intent: props.indent,
            editing: editing,
            edited: edited,
            'has-error': props.hasError,
            disabled: props.disabled,
        }"
    >
        <label>{{ translations.pay.discountVoucherCode }}</label>
        <input
            type="text"
            name="voucherCode"
            autocomplete="off"
            v-model="inputValue"
            @keyup="onInputKeyUp"
            @focus="onInputFocus"
            @blur="onInputBlur"
            :disabled="props.disabled"
        />
        <div v-if="showValidationIcon" class="icon" :class="{ active: iconActive }">
            <i class="fas fa-check"></i>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { translations } from "@/shared/localization/translations";
    import {computed, ref, watch} from "vue";

    const props = withDefaults(
        defineProps<{
            indent?: boolean;
            showValidationIcon?: boolean;
            disabled?: boolean;
            value?: string;
            onFocus?: {(hasFocus: boolean)};
            hasError: boolean;
        }>(),
        {
            indent: false,
            showValidationIcon: true,
            disabled: false,
            hasError: false,
        }
    );
    const emit = defineEmits(["update:value", "submit"]);

    const inputValue = ref(props.value ?? "");
    const editing = ref(false);
    const edited = ref(false);
    const iconActive = ref(false);
    
    const onInputKeyUp = (e: KeyboardEvent) => {
        checkVoucherInput();
        if (inputValue.value !== undefined) {
            inputValue.value = inputValue.value.toUpperCase();
        }
        
        emit("update:value", inputValue.value);

        if (isValid() && e.key === "Enter") {
            emit("submit");
        }
    };

    const onInputFocus = () => {
        editing.value = true;
        if (props.onFocus) {
          props.onFocus(true);
        }
    };

    const onInputBlur = () => {
        checkVoucherInput(true);
        editing.value = false;
        if (props.onFocus) {
          props.onFocus(false);
        }
    };

    const checkVoucherInput = (removeWhiteSpace = false) => {
      
        if (inputValue.value !== undefined && removeWhiteSpace) {
            inputValue.value = inputValue.value?.replace(/\s+/g, "");
        }

        edited.value = inputValue.value !== undefined && inputValue.value.length > 0;

        const isCodeValid = isValid();
        iconActive.value = isCodeValid;
    };

    const isValid = (): boolean => {
        return inputValue.value !== undefined && inputValue.value.length > 0;
    };

    watch(
        () => props.value,
        (newValue) => {
            inputValue.value = newValue ?? "";
        }
    );

    watch(inputValue, () => {
        emit("update:value", inputValue.value);
    });
</script>

<style lang="scss"></style>
